import * as Yup from "yup";

export const validationSchema = Yup.object({
  startDate: Yup.date().required("Start Date is required"),
  endDate: Yup.date().required("End Date is required"),
  dataType: Yup.string().required("Data Type is required"),
});
